import { cloneDeep, last } from 'lodash';
import { convertNumberToLetter, controlConfig_commissionRate } from '_libs/util';
import { Decimal } from 'decimal.js';

/**
 *
 * @param {*} data
 * @param {*} isApp
 * @param {*} defalutPlanCode - 指定 planCode
 * @returns
 */
export function getPremiumRateList({
  data,
  defalutPlanCode,
  isTXSystem,
  isRepeatPremiumRateWithFactors,
  isQuotePage = false,
}) {
  if (!data.premiumRateList || !data.premiumRateList.length) return {};
  const controlConfig = controlConfig_commissionRate[data.productId];

  let premiumRateList = cloneDeep(data.premiumRateList);
  if (data.productId == '345') {
    // 2025-10-29 CMSX-5609 345平安团体无忧保(工标B版) 只保留前两个费率档位，下架第三个档位
    premiumRateList = premiumRateList.filter(item => item.planCode != '3');
  } else if (data.productId == '205' && data.newBarPremiumRateList) {
    // 写死产品id 205 费率档位区间取值
    premiumRateList = data.newBarPremiumRateList;
  } else {
    premiumRateList = data.premiumRateList;
  }

  premiumRateList.sort((a, b) => {
    return a.premiumRate > b.premiumRate;
  });

  // 80124佣金率选中区间改造
  let premiumRateList80124 = [];
  if (isRepeatPremiumRateWithFactors) {
    let premiumRateList80124Value = [];
    data.premiumRateList.forEach((item) => {
      if (!premiumRateList80124Value.includes(item.premiumRate)) {
        premiumRateList80124Value.push(item.premiumRate);
      }
    });
    if (premiumRateList80124Value && premiumRateList80124Value.length) {
      premiumRateList80124Value.forEach((item, index) => {
        premiumRateList80124.push({
          planCode: index + 1,
          premiumRate: item,
        });
      });
    }
  }

  if (isQuotePage) {
    premiumRateList.forEach((item, index) => {
      let controlName = '';
      if (controlConfig) {
        const { planCodeSetStr } = controlConfig;
        if (planCodeSetStr) {
          const str = planCodeSetStr[item.planCode];
          if (str) {
            controlName = str;
          }
        }
      }
      if (controlName) {
        item.name = controlName;
      } else {
        if (data.productId == '80126') {
          item.name = convertNumberToLetter(index) + '档';
        } else {
          item.name = new Decimal(100).mul(new Decimal(item.premiumRate)).toNumber() + '%';
        }

        if (isTXSystem) {
          item.name = convertNumberToLetter(index) + '档';
        }
      }
    });
  }

  // 默认设置为最大
  let planCodeDefault = isRepeatPremiumRateWithFactors ? last(premiumRateList80124).planCode : last(premiumRateList).planCode;

  // 写死产品id 2001 计划 1
  if (
    data.productId == '2001' ||
    (data.factorRate && data.factorRate.planCodes && data.factorRate.planCodes.length)
  ) {
    planCodeDefault = '1';
  }

  // 写死产品id 205 计划 3
  if (data.productId == '205') {
    planCodeDefault = '3';
  }

  if (data.productId == '331') {
    planCodeDefault = '1';
  }
  if (data.productId == '332') {
    planCodeDefault = '4';
  }

  // 如果有指定佣金率
  if (defalutPlanCode) {
    if (premiumRateList.find((item) => item.planCode == defalutPlanCode)) {
      planCodeDefault = defalutPlanCode;
    }
  }

  console.log('💰 默认佣金档位', planCodeDefault);
  return {
    planCodeDefault,
    premiumRateList: isRepeatPremiumRateWithFactors ? premiumRateList80124 : premiumRateList,
  };
}



// WEBPACK FOOTER //
// ./src/util/premiumRate.js